import isEmpty from "lodash/isEmpty";
import { SET_CURR_USER, SET_RECENT_LIST, UPDATEPASSWORD_SUCCESS, UPDATE_CURR_USER, UPDATE_USER_AVAILABILITY_STATUS } from "../actions/action-types";

const initialState = {
  isAuthenticated: false,
  passwordUpdateSuccess: false,
  user: {},
  isGoogleUser: false,
  recentAssignmentList: [],
};

/**
 * setting states according to the type of actions
 * @param {*} state
 * @param {*} action
 * @returns {state}
 */

const auth = (state = initialState, action) => {
  switch (action.type) {
    case SET_CURR_USER:
      return {
        ...state,
        isAuthenticated: !isEmpty(action.user),
        user: {
          ...action.user,
          mode: state.user.mode ? state.user.mode : 0,
          lastSelectedBoard: localStorage.getItem("lastSelectedBoard") ?? "Grid",
          organisationPopUpShow: false,
          lastSelectedInteraction: state.user.lastSelectedInteraction ? state.user.lastSelectedInteraction : "Email",
          splitButtonType: "HOME",
          /* Initialize availabilityStatus if not present (default to "Available")
           */
          availabilityStatus:
            action.user?.availabilityStatus && (action.user.availabilityStatus === "Available" || action.user.availabilityStatus === "Away")
              ? action.user.availabilityStatus
              : state.user?.availabilityStatus && (state.user.availabilityStatus === "Available" || state.user.availabilityStatus === "Away")
              ? state.user.availabilityStatus
              : "Available",
        },
      };
    case UPDATEPASSWORD_SUCCESS:
      return {
        ...state,
        passwordUpdateSuccess: true,
      };
    case UPDATE_CURR_USER:
      return {
        ...state,
        user: { ...state.user, ...action.payload },
      };
    case SET_RECENT_LIST:
      return {
        ...state,
        recentAssignmentList: action.payload,
      };
    case UPDATE_USER_AVAILABILITY_STATUS:
      return {
        ...state,
        user: { ...state.user, availabilityStatus: action.payload },
      };
    default:
      return state;
  }
};

export default auth;
